import React from 'react';
import Select from 'react-select';

const MultiSelect = ({ value, onChange, options, placeholder }) => {
  return (
    <Select
      isMulti
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      isClearable
    />
  );
};

export default MultiSelect;
